var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKocLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 420,
    viewBox: "0 0 420 420",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Koc Insaat logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 420,
    rx: 36,
    fill: "#f4f6fb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(46,42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 28h42v120l84-120h52l-95 126 101 138h-54l-88-126v126H42V28z",
    fill: "#262464"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228,
    cy: 152,
    r: 106,
    fill: "none",
    stroke: "#262464",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228,
    cy: 152,
    r: 72,
    fill: "none",
    stroke: "#2c7bc6",
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228,
    cy: 152,
    r: 34,
    fill: "#e8f2ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKocLogo);
export default __webpack_public_path__ + "static/media/koc-logo.536aad1daf58a36f40a9cb2a946bfd39.svg";
export { ForwardRef as ReactComponent };